<template>
  <div class="job-map">
    <div class="container">
      <div class="map-container">
        <div id="map">
          <div v-if="loadingFlag" class="loading">
            <Loading type="spinner" color="#000" size="26"></Loading>
          </div>
        </div>
      </div>
    </div>
    <Popup :show="showJobInfo" closeable :position="device === 'mb' ? 'bottom' : 'center'" @clickOverlay="closeModel"
      @click-close-icon="closeModel" class="job-info-popup">
      <jobInfo v-if="showJobInfo && jobDetail.jobAdId" :jobDetail="jobDetail"></jobInfo>
    </Popup>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, inject, watch, nextTick } from "vue";
import { Popup, Loading } from "vant";
import AMapLoader from "@amap/amap-jsapi-loader";
import jobInfo from "./jobInfo.vue";
import provinceAll from "@/assets/location/provinceObj.json";
import cityAll from "@/assets/location/cityObj.json";
const map = ref(null);
const device = inject("device");
const showJobInfo = ref(false);
const loadingFlag = ref(true);
const props = defineProps({
  markers: {
    type: Array,
    default: () => []
  },
  jobDetail: {
    type: Object,
    default: {}
  }
})
const emit = defineEmits(['getJobDetail', 'clearDetail'])
watch(() => props.markers, (newVal, oldVal) => {
  if (newVal) {
    updateMarks()
  }
})
const clusterIndexSet = {
  province: {
    minZoom: 2,
    maxZoom: 5,
  },
  city: {
    minZoom: 5,
    maxZoom: 10,
  },
  hotelInglatKey: {
    minZoom: 10,
    maxZoom: 21,
  },
};
const initMap = () => {
  loadingFlag.value = true;
  AMapLoader.load({
    key: import.meta.env.VITE_APP_APP_MAP_KEY,
    version: "2.0",
    plugins: ["AMap.Scale", "AMap.ToolBar", "AMap.MouseTool", "AMap.IndexCluster", "AMap.LngLat"],
    Loca: {
      version: "2.0.0"
    }
  })
    .then((res) => {
      const lnglat = new res.LngLat(114.29, 30.54);
      map.value = new res.Map("map", {
        viewMode: "2D",
        zoom: 5,
        center: lnglat,
        resizeEnable: true
      });
      map.value.clearMap();
      map.value.addControl(new AMap.Scale());
      map.value.addControl(new AMap.ToolBar());
      //处理聚合点
      updateMarks()
    })
    .catch((e) => {
      console.log("error", e);
    }).finally(() => {
      loadingFlag.value = false;
    });
};
let currentIndexCluster = ref(null);
const updateMarks = () =>{
  loadingFlag.value = true;
  if (currentIndexCluster.value) {
    currentIndexCluster.value.setMap(null);
    currentIndexCluster.value = null;
  }
  // 自定义聚合点样式
  currentIndexCluster.value = new AMap.IndexCluster(map.value, props.markers, {
    renderClusterMarker: _renderClusterMarker,
    clusterIndexSet: clusterIndexSet,
  });
  loadingFlag.value = false;
}
const _renderClusterMarker =(context)=> {
  context.marker.setAnchor('center');
  const showData = getData(context)
  //创建标记点
  const div = createCustomDiv(showData)
  // 处理事件
  handleClick(context)
  context.marker.setContent(div)
  // 自定义聚合点标记显示位置
  const position = getPosition(context);
  if (position) {
    context.marker.setPosition(position);
  }
}


// 获取显示的数据
const getData =(context)=> {
  const clusterData = context.clusterData || [];
  let jobCount = 0
  clusterData.forEach(item => {
    jobCount += item.positionList?.length || 0;
  })
  return {
    mainKey: context.index.mainKey,
    jobCount
  }
}
// 处理div
const createCustomDiv =(data)=> {
  const markerContent = document.createElement("div");
  if (data.mainKey === 'hotelInglatKey') {
    markerContent.className = "location-marker";
    markerContent.innerHTML = data.jobCount || 0;
  } else {
    markerContent.className = "circle-marker";
    markerContent.innerHTML = data.jobCount || 0;
  }
  return markerContent
}

const createInfoWindowContent = (markerDataArray) => {
  const title = markerDataArray.map(item => item.hotel)
  return `
               <div class="custom-bubble">
                 <div class="bubble-header">
                    <div>
                      ${
                        title.map(item => `<span class="hotel-name">${item}</span>`).join('<br>')  
                      }
                    </div>
                    <i class="van-badge__wrapper van-icon van-icon-cross"></i>
                  </div>
                <div class="bubble-container">
                  ${
                    markerDataArray.map((markerData) => {
                      return `<div class="bubble-item">
                                    <div class="bubble-content">
                                      ${markerData.positionList
                                        .map(
                                          (job, index) =>
                                            `<div class="job-item" data-job-index="${index}" data-job-id="${job.jobId}">
                                                      <span class="job-value">${job.position}</span>
                                                      <i class="van-badge__wrapper van-icon van-icon-arrow"></i>
                                                    </div>`
                                        )
                                        .join("")}
                                    </div>
                                  </div>`
                    }).join("")
               }
                </div>
              </div>
            `;
};

const bindInfoWindowEvents = (infoWindow) => {
  setTimeout(() => {
    const jobItems = document.querySelectorAll(".job-item");
    const closeBtn = document.querySelectorAll(".van-icon-cross");
    const bubbleContent = document.querySelector(".bubble-container");
    if (bubbleContent) {
      bubbleContent.addEventListener("wheel", (e) => {
        e.stopPropagation();
      });

      bubbleContent.addEventListener("touchmove", (e) => {
        e.stopPropagation();
      });
    }
    jobItems.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        const jobId = item.dataset.jobId;
        handleJobInfo(jobId);
      });
    });
    closeBtn.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        infoWindow.close();
      });
    });
  }, 10);
};

const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
// 处理事件
const handleClick =(context)=> {
  if (context.index?.mainKey === 'hotelInglatKey') {
    const debouncedClickHandler = debounce((e)=>{
      const markerDataArray = context?.clusterData || []
      if (markerDataArray && markerDataArray.length > 0) {
        const content = createInfoWindowContent(markerDataArray);
        const infoWindow = new AMap.InfoWindow({
          isCustom: true,
          content: content,
          offset: new AMap.Pixel(0, -30),
          closeWhenClickMap: true
        });
        infoWindow.open(map.value, context.marker.getPosition());
        bindInfoWindowEvents(infoWindow);
      }
    },50)
    context.marker.on('click', debouncedClickHandler)
  } else {
    const debouncedClickHandler = debounce((e) => {
      let curZoom = map.value.getZoom();
      if (curZoom < 20) {
        curZoom = curZoom + 2.5;
      }
      map.value.setZoomAndCenter(curZoom, e.lnglat);
      map.value.setCenter(e.lnglat)
    },50)
    // 自定义点击事件
    context.marker.on('click', debouncedClickHandler);
  }
}
const getPosition =(context)=> {
  const key = context.index.mainKey;
  const dataItem = context.clusterData && context.clusterData[0];
  const addressName = dataItem[key]; // 省/市名字
  let lnglat = null
 
  if (key === 'province') {
    if (provinceAll.province[addressName]) {
      lnglat = provinceAll.province[addressName] // 获取省的中心点坐标
    }
  }
  if (key === 'city') {
    if (cityAll.city[addressName]) {
      lnglat = cityAll.city[addressName] // 获取市的中心点坐标
    }
  }
  if (lnglat) { //如果省/市中心点坐标没值
    const centerLnglat = new AMap.LngLat(lnglat[0], lnglat[1]);
    return centerLnglat;
  } else {
    return dataItem.lnglat // 如果省/市中心点坐标没值，就用第一个门店的坐标
  }
}
const handleJobInfo = (jobId) => {
  if (jobId) {
    showJobInfo.value = true;
    emit('getJobDetail', jobId)
  }
};
const closeModel = () => {
  showJobInfo.value = false
  nextTick(() => {
    emit('clearDetail')
  })
}
onMounted(() => {
  initMap();
});

onUnmounted(() => {
  if (map.value) {
    map.value.destroy();
    map.value = null;
  }
});
</script>

<style lang="scss" scoped>
.loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.job-map {
  margin-top: 32px;
  width: 100%;
}

#map {
  width: 100%;
  height: 574px;
  background: #f5f5f5;
  border-radius: 4px;
}

@media (max-width: 767px) {
  .job-map {
    margin-top: 0;
  }

  #map {
    height: calc(100vh - 110px);
  }
}

/* 自定义标记样式 */
:deep(.location-marker) {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMiA0QzE4LjgxODUgNC4wMDMzMSAxNS43Njg0IDUuMTYzMzEgMTMuNTE4NyA3LjIyNTUxQzExLjI2OSA5LjI4NzcxIDEwLjAwMzYgMTIuMDgzNyAxMCAxNS4wMDAxQzEwIDI0LjQxMjcgMjAuOTA5MSAzNS41MjE1IDIxLjM3NDEgMzUuODE5QzIxLjU1NzUgMzUuOTM2OCAyMS43NzYgMzYgMjIgMzZDMjIuMjI0IDM2IDIyLjQ0MjUgMzUuOTM2OCAyMi42MjU5IDM1LjgxOUMyMy4wOTA5IDM1LjUyMTUgMzQgMjQuNDEyNyAzNCAxNS4wMDAxQzMzLjk5NjQgMTIuMDgzNyAzMi43MzEgOS4yODc3MSAzMC40ODEzIDcuMjI1NTFDMjguMjMxNiA1LjE2MzMxIDI1LjE4MTUgNC4wMDMzMSAyMiA0WiIgZmlsbD0iI0MwMjhCOSIvPgogICAgPHBhdGggZD0iTTM0LjUgMTVDMzQuNSAxOS44Njk4IDMxLjY5MjMgMjUuMTA5NyAyOC44OTc1IDI5LjExNDNDMjcuNDkxNyAzMS4xMjg0IDI2LjA3MTYgMzIuODU0MiAyNC45NzM2IDM0LjA5NTdDMjQuNDI0NyAzNC43MTY0IDIzLjk1NDUgMzUuMjE3MiAyMy42MDU1IDM1LjU3NDJDMjMuNDMxNCAzNS43NTIzIDIzLjI4NjEgMzUuODk2NCAyMy4xNzQ4IDM2LjAwMkMyMy4wODE0IDM2LjA5MDYgMjIuOTczMyAzNi4xODkzIDIyLjg5NTUgMzYuMjM5M0MyMi42MjkyIDM2LjQxMDIgMjIuMzE2OSAzNi41IDIyIDM2LjVDMjEuNjgzIDM2LjUgMjEuMzY5OCAzNi40MTEzIDIxLjEwMzUgMzYuMjQwMlYzNi4yMzkzQzIxLjAyNTcgMzYuMTg5MiAyMC45MTg0IDM2LjA5MDMgMjAuODI1MiAzNi4wMDJDMjAuNzEzOSAzNS44OTY0IDIwLjU2ODYgMzUuNzUyMyAyMC4zOTQ1IDM1LjU3NDJDMjAuMDQ1NSAzNS4yMTcyIDE5LjU3NTMgMzQuNzE2NCAxOS4wMjY0IDM0LjA5NTdDMTcuOTI4NCAzMi44NTQyIDE2LjUwODMgMzEuMTI4NCAxNS4xMDI1IDI5LjExNDNDMTIuMzA3NyAyNS4xMDk3IDkuNSAxOS44Njk4IDkuNSAxNVYxNC45OTlMOS41MDM5MSAxNC43MTI5QzkuNTg3NTEgMTEuNzUzOSAxMC45MDY2IDguOTQxMDUgMTMuMTgwNyA2Ljg1NjQ1QzE1LjUyNjUgNC43MDYxNSAxOC42OTg3IDMuNTAzNTQgMjEuOTk5IDMuNUgyMi4wMDFMMjIuNjE4MiAzLjUxNDY1QzI1LjY5NDYgMy42NTc2MSAyOC42MjAxIDQuODQwNTYgMzAuODE5MyA2Ljg1NjQ1QzMzLjE2NjYgOS4wMDgxNCAzNC40OTYxIDExLjkzNTcgMzQuNSAxNC45OTlWMTVaIiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo=");
    background-repeat: no-repeat;
    background-size: contain;
    width: 44px;
    height: 45px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

:deep(.circle-marker) {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #c028b9;
    border: 1px solid white;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
  }
}

/* 气泡弹窗样式 */
:deep(.custom-bubble) {
  background: white;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 4px 12px 16px;
  width: 250px;
  transition: all 0.3s ease;
 

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    top: auto;
    bottom: -10px;
    left: 50%;
    border-width: 10px 10px 0 10px;
    border-color: white transparent transparent transparent;
  }

  .bubble-container{
    max-height: 100px;
    overflow-y: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }
/* 滚动条样式 */
.bubble-container::-webkit-scrollbar {
  width: 2px;
}

.bubble-container::-webkit-scrollbar-track {
  background: #f2f2f2;
  border-radius: 2px;
}

.bubble-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.bubble-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

  .bubble-header {
    font-size: 16px;
    color: #4d5660;
    padding-bottom: 8px;
    padding-right: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .hotel-name{
      padding: 4px 0;
    }
  }

  .van-icon-cross {
    cursor: pointer;
  }

  .job-item {
    padding: 4px 8px 4px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: var(--hc-font--headline);
    cursor: pointer;

    &:hover {
      transition: all 0.3s ease-in-out;

      .van-icon-arrow {
        transform: translateX(4px);
        color: rgba(192, 40, 185, 0.8);
      }
    }
  }

  .job-item .job-value {
    font-size: 16px;
    color: #000;
  }
}

/* 省级别聚合点样式 */
:deep(.province-cluster) {
  background-color: rgba(192, 40, 185, 0.8);
  border-radius: 6px;
  padding: 8px 12px;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

:deep(.province-cluster .province-name) {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}

:deep(.province-cluster .branch-count) {
  font-size: 12px;
  opacity: 0.9;
}

/* 城市级别聚合点样式 */
:deep(.city-cluster) {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(192, 40, 185, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.job-info-popup {
  height: 90vh;
  max-width: 1250px;
}

::v-deep(.van-popup__close-icon) {
  --van-popup-close-icon-margin: 32px;
  --van-popup-close-icon-color: #002F61;
  --van-popup-close-icon-size: 2rem;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: rotate(90deg);
    color: #000;
  }
}

@media (max-width: 767px) {
  ::v-deep(.van-popup__close-icon) {
    --van-popup-close-icon-margin: 24px;
    --van-popup-close-icon-size: 20px;
  }
}
</style>